import { createFileRoute } from '@tanstack/react-router';

import { LegalPage } from '@/features/legalPages/LegalPage';

export const Route = createFileRoute('/_static/terms')({
	component: TermsPage,
});

function TermsPage() {
	return <LegalPage page="terms" isPlaceholder />;
}
